<template>
   <div class="steps-line">
      <a class="arrow--container" @click="emitStatus(1)" :class="{'pointer-events-none':status <= 1 && origin_status < 1}"><div style="color: #158817; background-color: #158817" :class="{'complete': status > 1, 'current': status == 1}" class="arrow arrow__first"><span>
      <span class="!hidden md:!block">{{$t('Dati personali')}}</span>
      <span class="!block md:!hidden pr-[1rem]">1</span>
      </span></div></a>
      <a class="arrow--container" @click="emitStatus(2)" :class="{'pointer-events-none':status <= 2 && origin_status < 2}"><div style="color: #158817; background-color: #158817" :class="{'complete': status > 2, 'current': status == 2}" class="arrow"><span>
      <span class="!hidden md:!block">{{$t('Lingue')}}</span>
      <span class="!block md:!hidden pr-[1rem]">2</span>
      </span></div></a>
      <a class="arrow--container" @click="emitStatus(3)" :class="{'pointer-events-none':status <= 3 && origin_status < 3}"><div style="color: #158817; background-color: #158817" :class="{'complete': status > 3, 'current': status == 3}" class="arrow"><span>
      <span class="!hidden md:!block">{{$t('Dove vivo')}}</span>
      <span class="!block md:!hidden pr-[1rem]">3</span>
      </span></div></a>
      <a class="arrow--container" @click="emitStatus(4)" :class="{'pointer-events-none':status <= 4 && origin_status < 4}"><div style="color: #158817; background-color: #158817" :class="{'complete': status > 4, 'current': status == 4}" class="arrow"><span>
      <span class="!hidden md:!block">{{$t('Caratteristiche')}}</span>
      <span class="!block md:!hidden pr-[1rem]">4</span>
      </span></div></a>
      <!-- <a class="arrow--container" @click="emitStatus(5)" :class="{'pointer-events-none':status <= 5 && origin_status < 5}"><div style="color: #158817; background-color: #158817" :class="{'complete': status > 5, 'current': status == 5}" class="arrow"><span>
      <span class="!hidden md:!block">{{$t('Dati fiscali')}}</span>
      <span class="!block md:!hidden pr-[1rem]">5</span>
      </span></div></a> -->
      <a class="arrow--container" @click="emitStatus(6)" :class="{'pointer-events-none':status <= 6 && origin_status < 6}"><div style="color: #F4C52D; background-color: #F4C52D" :class="{'complete': status > 6, 'current': status == 6}" class="arrow arrow__last"><span>
      <span class="!hidden md:!block">{{$t('Media')}}</span>
      <span class="!block md:!hidden pr-[1rem]">6</span>
      </span></div></a>
   </div>
</template>

<script>
// import moment from "moment";

export default {
  props: ['status','origin_status'],
  methods: {
    emitStatus(new_status) {
      this.$emit("emitStatus",new_status)
    }
  },
};
</script>

<style lang="scss" scoped>
.steps-line{

    padding: 1rem 0;
    margin: 0 0 1rem 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid black;
  }
.arrow{
  content: '';
  position: relative;
  height: 100%;
  width: 100%;
  background-color: black;
  display: block;
  // clip-path: polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%, 10% 50%);
  clip-path: polygon(0 0, 95% 0, 100% 50%, 95% 100%, 0 100%, 5% 50%);

  span{
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: 700;
    margin-left: 3px;
    
    font-size: 14px;
    white-space: nowrap;

    @media screen and (max-width: 1400px) {font-size: 11px;}
  }

  &::before {
    content: "";
    display: block;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    height: 84%;
    width: 95%;
    background-color: white;
    // clip-path: polygon(0 0, 91% 0, 100% 50%, 91% 100%, 0 100%, 9% 50%);
    clip-path: polygon(0 0, 96% 0, 100% 50%, 96% 100%, 0 100%, 5% 50%);
    // /* clip-path: inherit; */
    /* clip-path: inherit; */
  }

  &__first{
    // clip-path: polygon(0 0, 90% 0, 100% 50%, 90% 100%, 0 100%, 0 50%);
    clip-path: polygon(0 0, 95% 0, 100% 50%, 95% 100%, 0 100%, 0 50%);
    &::before{
      width: 96%;
      // clip-path: polygon(0 0, 91% 0, 100% 50%, 91% 100%, 0 100%, 0 50%);
      clip-path: polygon(0 0, 96% 0, 100% 50%, 96% 100%, 0 100%, 0 50%);
    }
    span{
    margin-left: 0;
  }
  }
  &__last{
    // clip-path: polygon(0 0, 100% 0, 100% 50%, 100% 100%, 0 100%, 10% 50%);
    clip-path: polygon(0 0, 100% 0, 100% 50%, 100% 100%, 0 100%, 5% 50%);
    &::before{
      width: 95%;
      // clip-path: polygon(0 0, 100% 0, 100% 50%, 100% 100%, 0 100%, 9% 50%);
      clip-path: polygon(0 0, 100% 0, 100% 50%, 100% 100%, 0 100%, 5% 50%);
    }
  }

  &.complete{
    span{
      color: white;
    }
    &::before{
      display: none;
    }
  }

  &:not(.current){
    opacity: .5;
  }

  &--container{
    height: 35px;
    flex-grow: 1;
  }
}
</style>
